import React from "react";
import { SiteType } from "@/types";
import { decimalToSexagesimal } from "geolib";

type SiteListItemProps = {
  site: SiteType;
  active?: boolean;
  onClick: React.MouseEventHandler;
};

function SiteListItem({
  site,
  active = false,
  onClick,
}: Readonly<SiteListItemProps>) {
  return (
    <button
      className="flex flex-row items-center justify-between px-2 py-1 text-sm group min-w-0 rounded hover:bg-accent data-[state=default]:hover:cursor-pointer data-[state=active]:bg-primary"
      data-state={active ? "active" : "default"}
      onClick={onClick}
    >
      <span className="text-foreground group-data-[state=active]:text-primary-foreground">
        {site.site}
      </span>
      <em className="leading-tight font-normal not-italic text-xs truncate text-muted-foreground group-data-[state=active]:text-primary-foreground/60">
        {`${decimalToSexagesimal(site.latitude)} / ${decimalToSexagesimal(site.longitude)}`}
      </em>
    </button>
  );
}

export { SiteListItem };
